module.exports = __webpack_public_path__ + "static/img/handwrite.160cb39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/handwrite.png
// module id = icBE
// module chunks = 1